import { h } from 'preact';
import { accessNested } from 'utils/utils';
import * as BaseComp from 'components/bolt/footer/footer.js';
import s from 'components/bolt/footer/footer.sss';


if (typeof window !== 'undefined') {
	const onTidioChatApiReady = () => {
		window.tidioChatApi.hide();
		window.tidioChatApi.on('close', () => window.tidioChatApi.hide());
	};

	if (window.tidioChatApi) {
		window.tidioChatApi.on('ready', onTidioChatApiReady);
	} else {
		document.addEventListener('tidioChat-ready', onTidioChatApiReady);
	}
}

export default class Footer extends BaseComp.default {

	toggleFooter(state) {
		super.toggleFooter(state);
		window.firePowsterCustomEvent?.(`legal-click`, 'landing');
	}

	toggleLivechat() {
		window.tidioChatApi.show();
		window.tidioChatApi.open();
		window.firePowsterCustomEvent?.(`chat-click`, 'landing');
	}

	render(props, state) {
		const enableLiveChat = accessNested(props, 'store.appData.doc.headerScripts.tidioLiveChat', false);
		const buttonCopy = accessNested(props, 'store.appData.copy.baseCopy.$LIVE_CHAT_BUTTON') || 'Live Chat';
		const base = super.render(props, state);
		const chatButton = <button class={s.chatButton} onClick={this.toggleLivechat}>{buttonCopy}</button>;

		if (enableLiveChat) {
			base.children.push(chatButton);
		}

		return base;
	}
}
